<template>
  <QuickLook
    :horizontal="horizontal"
    :yearlyValues="yearlyValues"
    :horizon="horizon"
    :date="date"
  ></QuickLook>
</template>

<script>
import { DateTime } from "luxon";
import PCDashboardMixin from "@/mixins/PCDashboard";
import { formatNumber } from "@/plugins/utils";

export default {
  name: "PCQuickLook",
  components: {
    QuickLook: () => import("@/components/dashboards/QuickLook.vue"),
  },
  mixins: [PCDashboardMixin],
  props: {
    caseOutputs: { type: Object, required: false, default: () => ({}) },
    inputCase: { type: Object, required: false, default: () => ({}) },
    horizontal: { type: Boolean, required: false, default: false },
  },
  data() {
    return {};
  },
  computed: {
    mapping() {
      return [
        {
          title: "Peak Demand",
          format: 0,
          item: this.getOutput("demand_peak", this.input),
          suffix: "MW",
        },
        {
          title: "Storage Capacity",
          format: 0,
          item: this.storageQuickLook,
          suffix: "MW",
        },
        {
          title: "Average Price",
          format: 2,
          item: this.getOutput("zonal_price", this.output),
          suffix: "$/MWh",
        },
        {
          title: "Emission",
          format: 0,
          item: this.getOutput("co2_emissions", this.output),
          suffix: "ton",
        },
        {
          title: "Emission Cost",
          format: 0,
          item: this.getOutput("co2_emissions_cost", this.output),
          suffix: "$",
        },
      ];
    },
    yearlyValues() {
      return this.simulationYearArray.map((year, i) => ({
        year,
        values: this.mapping.map((el) => ({
          title: el.title,
          suffix: el.suffix,
          value: formatNumber(el.item[i], el.format),
        })),
      }));
    },
    date() {
      return DateTime.fromISO(this.inputCase.created).toLocaleString(DateTime.DATETIME_MED);
    },
  },
  watch: {},
  beforeCreate() {},
  created() {},
  beforeMount() {},
  mounted() {},
  beforeUpdate() {},
  updated() {},
  activated() {},
  deactivated() {},
  beforeDestroy() {},
  destroyed() {},
  methods: {
    formatNumber,
  },
};
</script>

<style></style>
